var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"white","width":"1200px","margin":"10px auto"}},[_c('div',{staticClass:"honor"},[_c('div',{staticClass:"title"},[_vm._v("联系我们")]),_c('div',{staticClass:"honorCont"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.honorinfo.cCONTENTS)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }